import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { PancakeStack, PancakeInput, PancakeLabel } from "./StyledPancakeToggle";
import { scales } from "./types";
var PancakeToggle = function(_param) /*#__PURE__*/ {
    var checked = _param.checked, _scale = _param.scale, scale = _scale === void 0 ? scales.LG : _scale, props = _object_without_properties(_param, [
        "checked",
        "scale"
    ]);
    return _jsxs(PancakeStack, {
        scale: scale,
        children: [
            /*#__PURE__*/ _jsx(PancakeInput, _object_spread({
                id: props.id || "pancake-toggle",
                scale: scale,
                type: "checkbox",
                checked: checked
            }, props)),
            /*#__PURE__*/ _jsx(PancakeLabel, {
                scale: scale,
                checked: checked,
                htmlFor: props.id || "pancake-toggle",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "pancakes",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "pancake"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "pancake"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "pancake"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "butter"
                        })
                    ]
                })
            })
        ]
    });
};
export default PancakeToggle;
